import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    const invalidField = this.element.querySelector('[aria-invalid="true"]')
    if (invalidField) invalidField.focus()
  }

  submit(event) {
    if (event.defaultPrevented || !this.element.checkValidity()) return
    const button = this.element.querySelector('[type="submit"]')
    button.disabled = true
    button.value = "Veido vērtētāju…"
  }
}
